import { useMemo } from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

import { useClearedQueryParamValue } from 'src/app/shared/hooks/location';

export function usePageBannerMessage(): string | undefined {
	const message = useClearedQueryParamValue('message');
	const { translate } = useI18n();

	return useMemo(() => {
		switch (message) {
			// coming from /sign-now (email one-click sign)
			case 'sign-success':
				return translate('fe.components.psf.promote_or_share.single_click.sign_success');
			default:
				return undefined;
		}
	}, [message, translate]);
}
